import { useEffect, useState } from 'react'
import { useDiscountCode } from '../../contexts/DiscountContext'
import { CookieKeys, getCookie } from '../../services/Cookies'
import { SessionKeys, SessionStorage } from '../../services/Session'
import { CloseButton, DiscountBannerRoot } from './DiscountBanner.styles'
import { DiscountBannerCopy } from './DiscountBannerCopy'
import {
  checkIfBannerAllowed,
  checkIfClickDisabled,
} from './discountBannerPageRules'

type DiscountBannerProps = {
  pathName: string
}

export const DiscountBanner = ({ pathName }: DiscountBannerProps) => {
  const [isHidden, setIsHidden] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const { discount, isLoading, refetchDiscountCode: refetch } =
    useDiscountCode()

  const isBannerAllowed = checkIfBannerAllowed(pathName)
  const isClickDisabled = checkIfClickDisabled(pathName)

  useEffect(() => {
    if (Boolean(SessionStorage().getItem(SessionKeys.BANNER_HIDE))) {
      setIsHidden(true)
    }
    setIsLoggedIn(Boolean(getCookie(CookieKeys.SESSION)))
    if (!discount) return
  }, [discount, refetch])

  useEffect(() => {
    if (!isHidden) return
    SessionStorage().setItem(SessionKeys.BANNER_HIDE, 'true')
  }, [isHidden])

  if (
    !discount ||
    isLoading ||
    !isBannerAllowed ||
    isLoggedIn
  )
    return null

  return (
    <DiscountBannerRoot
      isBlackFriday={discount.collection?.slug === 'black-friday'}
      display={!isHidden}
    >
      <DiscountBannerCopy
        primaryText={discount.primaryText}
        secondaryText={discount.secondaryText}
        disableClickPages={isClickDisabled}
      />
      <CloseButton hoverColor="red" aria-label="Close" onClick={() => setIsHidden(true)}>
        x
      </CloseButton>
    </DiscountBannerRoot>
  )
}

DiscountBanner.displayName = 'DiscountBanner'
